export default __webpack_public_path__ + "static/media/maxresdefault4.9d32e5ef.png";